import { Box, Tooltip } from '@mui/material'

interface InfoTipProps {
  text: string
  /** Nudges wide tooltips back inside a narrow rail. */
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

/**
 * The panel explains itself through these rather than through helper text: the
 * rule is twelve settings most people never touch, and a paragraph beside each
 * one turns a small form into a wall. Hover or keyboard focus reveals it.
 *
 * The bubble's look is the app-wide MuiTooltip theme (src/theme/theme.ts) —
 * this one only supplies the "i" target and a shorter delay, because the whole
 * point of the marker is that it answers straight away.
 */
const InfoTip = ({ text, placement = 'top' }: InfoTipProps) => (
  <Tooltip
    title={text}
    placement={placement}
    enterTouchDelay={0}
    enterDelay={120}
    enterNextDelay={120}
  >
    <Box
      component="span"
      tabIndex={0}
      role="note"
      aria-label={text}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 auto',
        width: 14,
        height: 14,
        borderRadius: '50%',
        border: '1px solid',
        borderColor: 'border.main',
        color: 'grey.600',
        fontSize: '9px',
        fontWeight: 700,
        lineHeight: 1,
        cursor: 'help',
        userSelect: 'none',
        transition: 'color 120ms ease, border-color 120ms ease, background-color 120ms ease',
        '&:hover, &:focus-visible': {
          color: 'primary.main',
          borderColor: 'primary.main',
          backgroundColor: 'rgba(0, 71, 68, 0.07)',
        },
      }}
    >
      i
    </Box>
  </Tooltip>
)

export default InfoTip
